import { use_slice_generation, use_slice_user } from '@/hooks/store/use_slices';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

export function HOOK_FIELD_IMAGES__get_fields_to_render() {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { user_settings } = use_slice_user(['user_settings']);

  /*
   *
   */

  const { graph } = generation_current.tool;

  /*
   * METHODS
   */

  function get_fields_lists_to_render() {
    if (generation_current.is_stub()) return [];

    let out: FIELD__list_image_asset[] = get_image_fields_lists();

    if (!user_settings.generation_fields_show_read_only) out = out.filter(field => field.is_ready_for_manual_edit());

    return out;
  }

  function get_image_fields_lists() {
    let out = [];

    let image_fields = graph.fields__get_by_type(FIELD__list_image_asset);

    for (let field of image_fields) {
      if (!field.meta.ui__has_component) continue; //no need to show
      if (field.meta.data__is_linked) continue; //show only sources

      out.push(field);
    }

    return out;
  }

  /*
   *
   */

  function get_fields_to_render() {
    if (generation_current.is_stub()) return [];

    let out: FIELD__image_asset[] = get_image_fields();

    if (!user_settings.generation_fields_show_read_only) out = out.filter(field => field.is_ready_for_manual_edit());

    return out;
  }

  function get_image_fields() {
    let out = [];

    let image_fields = graph.fields__get_by_type(FIELD__image_asset);

    for (let field of image_fields) {
      if (!field.meta.ui__has_component) continue; //no need to show
      if (field.meta.data__is_linked) continue; //show only sources

      out.push(field);
    }

    return out;
  }

  /*
   *
   */
  let fields_images = get_fields_to_render();
  let fields_images_lists = get_fields_lists_to_render();
  let fields_images_all = [...fields_images, ...fields_images_lists.flatMap(item => item.items)];

  return { fields_images, fields_images_lists, fields_images_all };
}
